 <!-- <div style="background-color: #fff;
 position: absolute;
 top: 0;
 width: 100%;"> -->


 <div class="container-fluid">
<!-- <nav class="navbar navbar-expand-sm justify-content-left">
  <ul class="navbar-nav">
    <a class="navbar-brand ml-3" href="#">
      <img
        src="./assets/images/Mcred_Logo-05.png"
        alt="Logo"
        style="width: 160px;"
      />
    </a>
  </ul>
</nav> -->
<!-- <hr class="hrcolor" /> -->
<div class="row topmargin">


  <div class="col-md-2"></div>
<div class="col-md-3" style="background-color: white;height: 30rem;color: black; border-top-left-radius: 20px; border-bottom-left-radius: 20px;">
    <h3 style="margin-top: 3rem;" class="text-center" ><b>Welcome to  </b> <a href="index.html"> <img
      src="./assets/images/Final_Logo-01.png"
      alt="Logo"
      style="width: 150px; "
    /></a></h3>
    <!-- <p class="text-bold text-center" style=" margin-bottom: 3rem; color: black; ">Handloom deserve a pride of place</p> -->
    <!-- Admin Login Form -->
    <div *ngIf="ptype == 'login'" style="margin-top:60px;">
      <form (ngSubmit)="signin()" [formGroup]="loginForm">
        <div class="form-group input-group margin-bottom-sm bg-light" style="border-radius: 18px; margin-bottom: 0;">
          <span class="input-group-addon mt-2 ml-2 mr-2"
            ><i class="mdi mdi-email"></i
          ></span>
          <input style="    border-radius: 20px;"
            type="text"
            placeholder="User Name"
            class="form-control"
            formControlName="Email"
            name="email"
          />
        </div>
        <div class="form-group">
          <small style="margin-left: 40px;"
            [hidden]="
              loginForm.controls.Email.valid ||
              loginForm.controls.Email.untouched
            "
            class="text-danger"
            translate
          >
            Username is required
          </small>
        </div>

        <div class="form-group input-group margin-bottom-sm bg-light"  style="border-radius: 18px; margin-bottom: 0px;">
          <span class="input-group-addon mt-2 ml-2 mr-2"
            ><i class="mdi mdi-lock-open-outline" aria-hidden="true"></i
          ></span>
          <input  style="    border-radius: 20px;"
            type="password"
            placeholder="Password"
            class="form-control"
            formControlName="Password"
            name="password"
          />
        </div>
        <div class="form-group">
          <small style="margin-left: 40px;"
            [hidden]="
              loginForm.controls.Password.valid ||
              loginForm.controls.Password.untouched
            "
            class="text-danger"
            translate
          >
            Password is required
          </small>
        </div>

        <div  class="text-right">
          <a (click)="openType('forgetPassword')" style="cursor: pointer; border-bottom: 1px solid black;"
            ><small >Forgot Password ?</small></a>
        </div>
        <br />
        <div class="text-center text-light form-group">
          <button style="border-radius: 18px;"
            type="submit"
            class="btn btn-danger text-light"
            [disabled]="loginForm.invalid"
          >
            <span class="ml-5 mr-5">Login</span>
          </button>
        </div>
      </form>
    </div>

    <div *ngIf="ptype == 'forgetPassword'">
      <p class="text-center mt-35 fs-10">
        Please enter your registered email to recieve OTP in order to change
        your password.
      </p>
      <div class="mt-25">
        <div class="form-group input-group margin-bottom-sm bg-light mb-2">
          <span class="input-group-addon mt-2 ml-2 mr-2"
            ><i class="mdi mdi-email"></i
          ></span>
          <input
            type="text"
            placeholder="Enter Email"
            [(ngModel)]="forgetPasswordEmail"
            class="form-control"
          />
        </div>
        <small style="margin-left: 33px;"
          [hidden]="!showForgetPasswordValidation"
          class="text-danger"
          translate
        >
          {{ forgetPasswordValidationText }}
        </small>
        <div class="text-right">
          <a (click)="openType('login')" style="cursor: pointer;  border-bottom: 1px solid black; "><small>Login</small></a>
        </div>
        <div class="text-center" style="margin-bottom: 20px;">
          <button style="border-radius: 18px;"
            type="button"
            class="btn btn-danger "
            (click)="forgetPasswordClick()"
          >
            Send OTP
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="ptype == 'changePassword'">
      <p class="text-center text-white mt-35 fs-20">Password Update</p>
      <div class="ml-3 mt-25">
        <div class="form-group bg-light" style="margin-bottom: 6px !important;">
          <input
            type="text"
            [(ngModel)]="passwordmodel.Otp"
            placeholder="Enter OTP"
            class="form-control gc_input"
          />
        </div>
        <small class="text-danger"
        translate>
          {{ optValidation }}
        </small>
        <div class="form-group bg-light" style="margin-bottom: 6px !important;">
          <input
            type="text"
            [(ngModel)]="passwordmodel.Newpwd"
            placeholder="New Password"
            class="form-control gc_input"
          />
        </div>
        <small class="text-danger"
        translate>
          {{ newPasswordValidation }}
        </small>
        <div class="form-group bg-light" style="margin-bottom: 6px !important;">
          <input
            type="text"
            [(ngModel)]="passwordmodel.Cnewpwd"
            placeholder="Retype Password"
            class="form-control gc_input"
          />
        </div>
        <small class="text-danger"
        translate>
          {{ cNewPasswordValidation }}
        </small>
        <div>
          <div class="text-right">
            <a (click)="openType('login')" style="cursor: pointer;">Login</a>
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn buttonradius text-light"
            (click)="resetPasswordClick()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
    <div class="gobackhome" style="text-align: center;">
       <a href="index.html" style="color:black;"><i class="fa fa-angle-double-left" aria-hidden="true" style="color:black;font-size:20px;"></i> Go Back</a>
    </div>
  </div>

  <div class="col-md-5" style="padding-left: 0px !important; ">
    <img
      src="./assets/images/mcred-login.png"
      alt="admin poster"
      style="width: 110%; height: 30rem; border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;"
    />
  </div>


</div>

</div>
<!-- </div> -->
